<template>
  <div>
    <GlobalHeader />
    <div class="categoryHead">
      <div class="inner">
        <nav class="categoryHeadArea">
          <ul class="talkshowMenu">
            <li><router-link to="/talkshows" :class="{ location: isSelected('/talkshows') }" class="rMeun01">アーカイブ動画</router-link></li>
            <!-- <li><router-link to="/talkshows/report" :class="{ location: isSelected('/talkshows/report') }">トークショーレポート</router-link></li> -->
            <li><router-link to="/talkshows/report_nikon" :class="{ location: isSelected('/talkshows/report_nikon') }" class="rMeun02"><span class="menuSubTxt">トークショーレポート：ニコンイメージングジャパン</span><span class="menuMainTxt">フルサイズミラーレスで出会う美しい世界</span></router-link></li>
            <li><router-link to="/talkshows/report_fujifilm" :class="{ location: isSelected('/talkshows/report_fujifilm') }" class="rMeun03"><span class="menuSubTxt">トークショーレポート：富士フイルム株式会社</span><span class="menuMainTxt">世界は色を変える。新しいXとともに</span></router-link></li>            <li><router-link to="/talkshows/report_raytrek" :class="{ location: isSelected('/talkshows/report_raytrek') }" class="rMeun04"><span class="menuSubTxt">トークショーレポート：株式会社サードウェーブ</span><span class="menuMainTxt">PCレタッチで変わる写真表現</span></router-link></li>
          </ul>
        </nav>
      </div><!-- /inner-->
    </div><!-- /categoryHead-->
  </div>
</template>

<script>
import GlobalHeader from './GlobalHeader'

export default {
  components: {
    GlobalHeader
  },
  methods: {
    isSelected (str) {
      if (str === '/talkshows') {
        if (this.$route.path.indexOf(str) >= 0) {
          const pathList = this.$route.path.split('/')
          if (pathList && pathList.length < 3) {
            return true
          }
        }
        return false
      } else {
        return this.$route.path.indexOf(str) >= 0
      }
    }
  }
}
</script>
